module.exports = __webpack_public_path__ + "img/dark-footer-2.d5388e3c.png";